import { createSlice } from "@reduxjs/toolkit";

import {
  addInvoiceGenerationAction,
  addOtherInvoiceGenerationAction,
  approveInvoiceAction,
  assignInvoiceColumnsToClientAction,
  checkDuplicateEntryAction,
  copyInvoiceGenerationAction,
  deleteInvoiceAction,
  deleteOtherInvoiceAction,
  getAllExpensesInvoicesListAction,
  getAllInvoiceColumnsListAction,
  getAllMappedClientColumnListAction,
  getAllOtherInvoicesListAction,
  getAllRevenuInvoicesListAction,
  getInvoiceAllComment,
  getPaymentPendingList,
  getSingleInvoiceDetailsAction,
  getSingleOtherInvoiceDetailsAction,
  invoiceGenerationBulkUploadAction,
  postInvoiceAllComment,
  updateInvoiceGenerationAction,
  updateOtherInvoiceGenerationAction,
  getAllAllocationListAction,
  postLockingEntryAction,
  invoiceNotesListAction,
  getEinvoiceDataAction,
  getReviewEinvoiceDataAction,
  postEinvoiceDataAction,
  postCancelEinvoiceDataAction,
  sendOverdueEmailApiAction,
  invoiceGenerationRevenuesBulkUploadAction,
  invoiceGenerationExpensesBulkUploadAction,
  getInvoiceCustomerInvoiceDownload,
  getBomDataAction,
  postBomDataAction,
  updateBomDataAction,
  getSingleBomDataAction,
  getBOMSavedTemplateListAction,
  getSingleBomTemplateDataAction,
  uniqueCheckBOMSavedTemplateNameAction,
  getInvoiceHistoryDataAction,
  getBulkUploadHistoryAction,
  getOthersInvoiceHistoryDataAction,
  invoiceGenerationSuspenseBulkUploadAction,
  getReviewEWayBillDataAction,
  getGenerateEWayBillAction,
  cancelEWayBillDataAction,
  postExtendEWayBillAction,
  checkDistanceCountAction,
  postEinvoiceAuthenticationAction,
  postEwayBillAuthenticationAction,
  postLockingEntryBOMAction,
  postInvoiceOcrAction,
  updateVehicleEWayBillDetails,
  updateTransporterEWayBillDetails,
  getClientColumnAssignedListAction,
  getGstrTwoATwoBComparePayloadAction,
  initialState,
  invoiceGenerationReducer,
  getClientInvoiceOnboardingStatusAction,
  sendInvoiceGenerationEmailAction,
  deleteBomEntryAction,
} from "@/redux/invoiceGeneration";
import type { InvoiceGenerationTypes } from "@/redux/invoiceGeneration/invoiceGenrationTypes";

export const invoiceGenerationSlice = createSlice({
  name: "invoiceGeneration",
  initialState,
  reducers: invoiceGenerationReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getAllInvoiceColumnsListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllInvoiceColumnsListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = {}, message, status_code, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          allColumnsList: result,
        };
      }
    );

    builder.addCase(
      getAllInvoiceColumnsListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        error: error?.message ?? null,
        success: 0,
        fetching: false,
      })
    );

    builder.addCase(
      getAllMappedClientColumnListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllMappedClientColumnListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = [], message, status_code, success } = payload;
        const { expenses, revenues, others } = result;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          mappedExpensesColumnsList: expenses,
          mappedRevenueColumnsList: revenues,
          mappedOthersColumnList: others,
          message,
        };
      }
    );

    builder.addCase(
      getAllMappedClientColumnListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        error: error?.message ?? null,
        success: 0,
        fetching: false,
      })
    );

    builder.addCase(
      assignInvoiceColumnsToClientAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      assignInvoiceColumnsToClientAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = {}, message, status_code, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      assignInvoiceColumnsToClientAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addInvoiceGenerationAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addInvoiceGenerationAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = {}, message, status_code, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      addInvoiceGenerationAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateOtherInvoiceGenerationAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateOtherInvoiceGenerationAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = {}, status_code, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          success,
          fetching: false,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateOtherInvoiceGenerationAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addOtherInvoiceGenerationAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addOtherInvoiceGenerationAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = {}, status_code, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          success,
          fetching: false,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      addOtherInvoiceGenerationAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllOtherInvoicesListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllOtherInvoicesListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            statusCode: status_code,
            error: message,
            fetching: false,
          };
        }

        return {
          ...state,
          allOtherInvoicesList: result?.data,
          otherInvoicesTotal: result?.total_count,
          lockOthersEntriesDate: result?.lock_entry_date,
          fetching: false,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getAllOtherInvoicesListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllExpensesInvoicesListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllExpensesInvoicesListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          expensesInvoicesTotal: result?.total_count,
          allExpensesInvoicesList: result?.data,
          lockExpensesEntriesDate: result?.lock_entry_date,
        };
      }
    );

    builder.addCase(
      getAllExpensesInvoicesListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllRevenuInvoicesListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllRevenuInvoicesListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          revenueInvoicesTotal: result?.total_count,
          allRevenueInvoicesList: result?.data,
          lockRevenueEntriesDate: result?.lock_entry_date,
        };
      }
    );

    builder.addCase(
      getAllRevenuInvoicesListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getSingleInvoiceDetailsAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleInvoiceDetailsAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, message, success, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            success,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleInvoiceDetails: result,
        };
      }
    );

    builder.addCase(
      getSingleInvoiceDetailsAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      postInvoiceOcrAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postInvoiceOcrAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, message, success, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            success,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleInvoiceDetails: result,
        };
      }
    );

    builder.addCase(
      postInvoiceOcrAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateInvoiceGenerationAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateInvoiceGenerationAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      updateInvoiceGenerationAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      copyInvoiceGenerationAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      copyInvoiceGenerationAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      copyInvoiceGenerationAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      deleteInvoiceAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteInvoiceAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteInvoiceAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      deleteBomEntryAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteBomEntryAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteBomEntryAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      deleteOtherInvoiceAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteOtherInvoiceAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteOtherInvoiceAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getSingleOtherInvoiceDetailsAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleOtherInvoiceDetailsAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result, status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleOtherInvoiceDetails: result?.[0],
        };
      }
    );

    builder.addCase(
      getSingleOtherInvoiceDetailsAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      invoiceGenerationBulkUploadAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      invoiceGenerationBulkUploadAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        // @ts-ignore [TODO:] Need to remove this ts-ignore by giving proper type
        const { success, message, status_code, data = {} } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bulkUploadData: data,
        };
      }
    );

    builder.addCase(
      invoiceGenerationBulkUploadAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      invoiceGenerationSuspenseBulkUploadAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      invoiceGenerationSuspenseBulkUploadAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        // @ts-ignore [TODO:] Need to remove this ts-ignore by giving proper type
        const { success, message, status_code, data = {} } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bulkUploadData: data,
        };
      }
    );

    builder.addCase(
      invoiceGenerationSuspenseBulkUploadAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      invoiceGenerationRevenuesBulkUploadAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      invoiceGenerationRevenuesBulkUploadAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        // @ts-ignore [TODO:] Need to remove this ts-ignore by giving proper type
        const { success, message, status_code, data = {} } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bulkUploadData: data,
        };
      }
    );

    builder.addCase(
      invoiceGenerationRevenuesBulkUploadAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      invoiceGenerationExpensesBulkUploadAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      invoiceGenerationExpensesBulkUploadAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        // @ts-ignore [TODO:] Need to remove this ts-ignore by giving proper type
        const { success, message, status_code, data = {} } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bulkUploadData: data,
        };
      }
    );

    builder.addCase(
      invoiceGenerationExpensesBulkUploadAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      checkDuplicateEntryAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      checkDuplicateEntryAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, is_duplicate_invoice } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          isDuplicateEntry: is_duplicate_invoice,
        };
      }
    );

    builder.addCase(
      checkDuplicateEntryAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getInvoiceAllComment.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getInvoiceAllComment.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          allComments: result,
        };
      }
    );

    builder.addCase(
      getInvoiceAllComment.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getInvoiceCustomerInvoiceDownload.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        pdfFetching: true,
      })
    );

    builder.addCase(
      getInvoiceCustomerInvoiceDownload.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            pdfFetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          pdfFetching: false,
          statusCode: status_code,
          customerSingleInvoiceData: result,
        };
      }
    );

    builder.addCase(
      getInvoiceCustomerInvoiceDownload.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        pdfFetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      postInvoiceAllComment.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postInvoiceAllComment.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          commentsSuccess: success,
        };
      }
    );

    builder.addCase(
      postInvoiceAllComment.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      approveInvoiceAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      approveInvoiceAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          approvalSuccess: success,
        };
      }
    );

    builder.addCase(
      approveInvoiceAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getPaymentPendingList.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getPaymentPendingList.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          paymentPendingList: result,
        };
      }
    );

    builder.addCase(
      getPaymentPendingList.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getAllAllocationListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllAllocationListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          allAllocationList: result,
        };
      }
    );

    builder.addCase(
      getAllAllocationListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      postLockingEntryAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postLockingEntryAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postLockingEntryAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      invoiceNotesListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      invoiceNotesListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          // success,
          invoiceNotesList: result?.data,
          // message
        };
      }
    );

    builder.addCase(
      invoiceNotesListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getEinvoiceDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getEinvoiceDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          eInvoiceData: result,
          message,
        };
      }
    );

    builder.addCase(
      getEinvoiceDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getReviewEinvoiceDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getReviewEinvoiceDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          eInvoiceReviewData: result,
          message,
        };
      }
    );

    builder.addCase(
      getReviewEinvoiceDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getBomDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getBomDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bomListData: result,
          lockBOMEntriesDate: result?.lock_entry_date,
        };
      }
    );

    builder.addCase(
      getBomDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getBOMSavedTemplateListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getBOMSavedTemplateListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bomSavedTemplateListData: result,
        };
      }
    );

    builder.addCase(
      getBOMSavedTemplateListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      postBomDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postBomDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postBomDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      updateBomDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateBomDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateBomDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      postEinvoiceDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postEinvoiceDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
            eInvoiceError: result?.data?.ErrorDetails,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postEinvoiceDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      postCancelEinvoiceDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postCancelEinvoiceDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
            eInvoiceError: result?.data?.ErrorDetails,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postCancelEinvoiceDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      postEinvoiceAuthenticationAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postEinvoiceAuthenticationAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postEinvoiceAuthenticationAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      postEwayBillAuthenticationAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postEwayBillAuthenticationAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postEwayBillAuthenticationAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      sendOverdueEmailApiAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      sendOverdueEmailApiAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            overDueEmailSuccess: success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          overDueEmailSuccess: success,
          overDueEmailMessage: message,
        };
      }
    );

    builder.addCase(
      sendOverdueEmailApiAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getSingleBomDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleBomDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleBomData: result,
        };
      }
    );

    builder.addCase(
      getSingleBomDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getSingleBomTemplateDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleBomTemplateDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleBomTemplateData: result,
        };
      }
    );

    builder.addCase(
      getSingleBomTemplateDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getInvoiceHistoryDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        bulkUploadFetching: true,
      })
    );

    builder.addCase(
      getInvoiceHistoryDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            bulkUploadFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          bulkUploadFetching: false,
          statusCode: status_code,
          invoiceHistoryData: result,
          invoiceHistoryCount: total_count,
        };
      }
    );

    builder.addCase(
      getInvoiceHistoryDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getOthersInvoiceHistoryDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        bulkUploadFetching: true,
      })
    );

    builder.addCase(
      getOthersInvoiceHistoryDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;

        if (success === 0) {
          return {
            ...state,
            bulkUploadFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          bulkUploadFetching: false,
          statusCode: status_code,
          othersHistoryData: result,
          othersHistoryCount: total_count,
        };
      }
    );

    builder.addCase(
      getOthersInvoiceHistoryDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getBulkUploadHistoryAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getBulkUploadHistoryAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success, count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          bulkUploadHistoryData: result,
          bulkUploadCount: count,
        };
      }
    );

    builder.addCase(
      getBulkUploadHistoryAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      uniqueCheckBOMSavedTemplateNameAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        templateFetching: true,
      })
    );

    builder.addCase(
      uniqueCheckBOMSavedTemplateNameAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, result, message, success } = payload;

        if (success === 0) {
          return {
            ...state,
            templateFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          templateFetching: false,
          statusCode: status_code,
          singleBomTemplateData: result,
          uniqueTemplateNameMessage: message,
        };
      }
    );

    builder.addCase(
      uniqueCheckBOMSavedTemplateNameAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        templateFetching: false,
      })
    );

    builder.addCase(
      getReviewEWayBillDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getReviewEWayBillDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          eWayBillReviewData: result,
        };
      }
    );

    builder.addCase(
      getReviewEWayBillDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getGenerateEWayBillAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getGenerateEWayBillAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
            eWayBillError: result?.data?.info
              ? result?.data?.info
              : result?.message,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          // eWayBillReviewData: result,
          success,
          message,
        };
      }
    );

    builder.addCase(
      getGenerateEWayBillAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      cancelEWayBillDataAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      cancelEWayBillDataAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
            eWayBillError: result?.data?.info
              ? result?.data?.info
              : result?.message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      cancelEWayBillDataAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      postExtendEWayBillAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postExtendEWayBillAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
            eWayBillError: result?.data?.info
              ? result?.data?.info
              : result?.message,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          // eWayBillReviewData: result,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postExtendEWayBillAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      updateVehicleEWayBillDetails.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateVehicleEWayBillDetails.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
            eWayBillUpdateError: result?.data?.info
              ? result?.data?.info
              : result?.message,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          // eWayBillReviewData: result,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateVehicleEWayBillDetails.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      updateTransporterEWayBillDetails.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateTransporterEWayBillDetails.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            error: message,
            success,
            eWayBillUpdateError: result?.data?.info
              ? result?.data?.info
              : result?.message,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          // eWayBillReviewData: result,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateTransporterEWayBillDetails.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      checkDistanceCountAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        pinCodeFetching: true,
      })
    );

    builder.addCase(
      checkDistanceCountAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { data } = payload;
        if (data?.success === 0) {
          return {
            ...state,
            pinCodeFetching: false,
            statusCode: data?.status_code,
            // // error: message,
            // success:0,
            pinCodeDistanceCountData: data?.result,
            pinCodeError: data?.result?.message,
          };
        }
        return {
          ...state,
          pinCodeFetching: false,
          statusCode: data?.status_code,
          // eWayBillReviewData: result,
          pinCodeDistanceCountData: data?.result,
          success: data?.success,
          message: data?.result?.message,
        };
      }
    );

    builder.addCase(
      checkDistanceCountAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => {
        return {
          ...state,
          pinCodeFetching: false,
          pinCodeError: error?.message || "",
          success: 0,
        };
      }
    );

    builder.addCase(
      postLockingEntryBOMAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      postLockingEntryBOMAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
    );

    builder.addCase(
      postLockingEntryBOMAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getClientColumnAssignedListAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientColumnAssignedListAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = [], message, status_code, success } = payload;
        const { expenses, revenues, others } = result;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            isClientColumnAssignedSuccess: success,
            statusCode: status_code,
            isClientColumnAssignedMessage: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          // mappedExpensesColumnsList: expenses,
          // mappedRevenueColumnsList: revenues,
          // mappedOthersColumnList: others,
          isClientColumnAssignedMessage: message,
        };
      }
    );

    builder.addCase(
      getClientColumnAssignedListAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        isClientColumnAssignedMessage: error?.message ?? null,
        isClientColumnAssignedSuccess: 0,
        fetching: false,
      })
    );

    builder.addCase(
      getGstrTwoATwoBComparePayloadAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getGstrTwoATwoBComparePayloadAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, message, success, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            statusCode: status_code,
            success,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          singleInvoiceDetails: result,
        };
      }
    );

    builder.addCase(
      getGstrTwoATwoBComparePayloadAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
    builder.addCase(
      getClientInvoiceOnboardingStatusAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getClientInvoiceOnboardingStatusAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { result = {}, message, status_code, success } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            clientOnboardingSuccess: success,
            clientOnboardingError: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          clientOnboardingSuccess: success,
          clientOnboardingData: result,
          statusCode: status_code,
        };
      }
    );
    builder.addCase(
      getClientInvoiceOnboardingStatusAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        clientOnboardingSuccess: 0,
        clientOnboardingError: error?.message ?? null,
      })
    );

    builder.addCase(
      sendInvoiceGenerationEmailAction.pending,
      (state: InvoiceGenerationTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      sendInvoiceGenerationEmailAction.fulfilled,
      (state: InvoiceGenerationTypes, { payload }) => {
        const { status_code, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            invoiceGenerationEmailMessage: message,
            statusCode: status_code,
            invoiceGenerationEmailSuccess: success,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          invoiceGenerationEmailSuccess: success,
          invoiceGenerationEmailMessage: message,
        };
      }
    );

    builder.addCase(
      sendInvoiceGenerationEmailAction.rejected,
      (state: InvoiceGenerationTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );
  },
});

export const {
  resetInvoiceGenerationError,
  resetInvoiceGenerationFetching,
  resetInvoiceGenerationSuccess,
  resetMappedExpensesColumnList,
  resetMappedOtherColumnList,
  resetMappedRevenueColumnList,
  resetGetAllOtherInvoicesList,
  resetExpenseInvoicesList,
  resetRevenueInvoicesList,
  resetSingleInvoiceDetails,
  resetSingleOtherInvoiceDetails,
  resetUpdateInvoiceGenerationSuccess,
  resetUpdateInvoiceGenerationError,
  resetError: resetInvoicingError,
  resetSuccess: resetInvoicingSuccess,
  resetStatusCode: resetInvoiceStatusCode,
  resetInvoicingFetching,
  resetBulkUploadData,
  resetDuplicateEntry,
  resetApprovalSuccess,
  resetcommentsSuccess,
  resetExpenseInvoicesTotal,
  resetRevenueInvoicesTotal,
  resetOtherInvoicesTotal,
  resetSuccess,
  resetAllocationList,
  resetAllAllocationList,
  resetEinvoiceReviewData,
  resetEinvoiceData,
  resetEinvoiceError,
  resetEWayBillError,
  resetInvoiceNotesList,
  resetInvoiceGenerationOverDueEmailSuccess,
  resetSingleInvoiceData,
  resetBomDataList,
  resetSingleBomData,
  resetInvoiceGenerationOverDueEmailMessage,
  resetSingleBomTemplateData,
  resetBomSavedTemplateListData,
  resetUniqueTemplateNameMessage,
  resetInvoiceHistoryData,
  resetBulkUploadHistoryData,
  resetBulkUploadHistoryCount,
  resetOthersHistoryData,
  resetOthersHistoryCount,
  resetEWayBillReviewData,
  resetPinCodeError,
  resetPinCodeDistanceCountData,
  resetLockBomEntriesDate,
  resetEWayBillUpdateError,
  resetIsClientColumnAssignedSuccess,

  resetIsClientColumnAssignedMessage,
  resetClientOnboardingData,
  resetClientOnboardingError,
  resetClientOnboardingSuccess,
  resetClientOnboardingMessage,
  resetInvoiceGenerationEmailSuccess,
} = invoiceGenerationSlice.actions;
